import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LibModule } from '@ui-components/lib.module';
import { InviteComponent } from './invite.component';

@NgModule({
  declarations: [
    InviteComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTooltipModule,
    LibModule
  ],
})
export class InviteModule { }
